/** Join only non-empty parts so generated labels never end in ` - ` or `Uhr in `. */
export function joinPresent(
  parts: Array<string | number | null | undefined>,
  separator: string
): string {
  return parts
    .map(part => (part === null || part === undefined ? '' : String(part).trim()))
    .filter(part => part !== '')
    .join(separator);
}
